// SymbolPlugin.ts
// Custom CKEditor 5 plugin to insert symbols into the editor
// Drop this file into your project and import it in CKEditorComponent

import { createDropdown, Plugin } from "ckeditor5";

// ─── Symbol data ──────────────────────────────────────────────────────────────

export const SYMBOL_GROUPS: { label: string; symbols: string[] }[] = [
  {
    label: "Toán học & Hình học",
    symbols: [
      "±", "÷", "×", "√", "∞", "≈", "≤", "≥", "≠", "°",
      "∠", "π", "◆", "◇", "△", "▽", "∑", "∏", "∫", "∂",
      "∈", "∉", "⊂", "⊃", "∪", "∩", "∅", "⊥", "∥", "∼",
    ],
  },
  {
    label: "Bản quyền & Thương hiệu",
    symbols: ["©", "®", "™", "℗", "℠"],
  },
  {
    label: "Tiền tệ",
    symbols: ["$", "€", "£", "¥", "₫", "₩", "₹", "¢", "₿", "₽"],
  },
  {
    label: "Mũi tên & Chỉ hướng",
    symbols: [
      "←", "↑", "→", "↓", "↔", "↕", "↖", "↗", "↘", "↙",
      "⇐", "⇑", "⇒", "⇓", "⇔", "⇕", "➔", "➜", "➝", "➞",
    ],
  },
  {
    label: "Văn phòng / Liên hệ",
    symbols: ["📞", "✉", "📧", "👤", "📄", "🖨", "📎", "📌", "🔒", "🔓"],
  },
  {
    label: "Cảm xúc & Ngôi sao",
    symbols: ["☺", "☹", "★", "☆", "♥", "♦", "♣", "♠", "✓", "✗", "✔", "✘"],
  },
  {
    label: "Dấu câu đặc biệt",
    symbols: ["–", "—", "…", "«", "»", "‹", "›", "\u201C", "\u201D", "\u2018", "\u2019", "§", "¶", "†", "‡"],
  },
]

// ─── Plugin ───────────────────────────────────────────────────────────────────

export class SymbolPlugin extends Plugin {
  static get pluginName() {
    return "SymbolPlugin" as const
  }

  init() {
    const editor = this.editor
    const t = editor.t

    editor.ui.componentFactory.add("symbolPicker", (locale) => {
      const dropdownView = createDropdown(locale)

      dropdownView.buttonView.set({
        label: "Ký hiệu",
        tooltip: true,
        withText: true,
        // Use Ω as the icon-like label
        icon: false,
      })

      // Override the button label to show Ω symbol
      dropdownView.buttonView.set({ label: "Ký hiệu" })

      // Build the panel content lazily
      dropdownView.on("change:isOpen", () => {
        if (dropdownView.panelView.element && dropdownView.panelView.element.childNodes.length > 0) {
          return // already rendered
        }

        const container = document.createElement("div")
        container.style.cssText = `
          max-width: 420px;
          max-height: 340px;
          overflow-y: auto;
          padding: 8px 10px;
          font-family: inherit;
        `

        SYMBOL_GROUPS.forEach((group) => {
          const groupLabel = document.createElement("div")
          groupLabel.textContent = group.label
          groupLabel.style.cssText = `
            font-size: 11px;
            font-weight: 700;
            color: #888;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            padding: 6px 0 4px;
            border-bottom: 1px solid #eee;
            margin-bottom: 4px;
          `
          container.appendChild(groupLabel)

          const grid = document.createElement("div")
          grid.style.cssText = `
            display: flex;
            flex-wrap: wrap;
            gap: 2px;
            margin-bottom: 8px;
          `

          group.symbols.forEach((sym) => {
            const btn = document.createElement("button")
            btn.textContent = sym
            btn.type = "button"
            btn.title = sym
            btn.style.cssText = `
              width: 32px;
              height: 32px;
              font-size: 16px;
              line-height: 1;
              background: transparent;
              border: 1px solid transparent;
              border-radius: 4px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: background 0.12s, border-color 0.12s;
              color: #1a1a1a;
            `

            btn.addEventListener("mouseenter", () => {
              btn.style.background = "#f0f4ff"
              btn.style.borderColor = "#a0b4f0"
            })
            btn.addEventListener("mouseleave", () => {
              btn.style.background = "transparent"
              btn.style.borderColor = "transparent"
            })

            btn.addEventListener("mousedown", (e) => {
              e.preventDefault() // keep editor focus
            })

            btn.addEventListener("click", () => {
              editor.model.change((writer) => {
                const insertPosition = editor.model.document.selection.getFirstPosition()
                writer.insertText(sym, insertPosition!)
              })
              dropdownView.isOpen = false
              editor.editing.view.focus()
            })

            grid.appendChild(btn)
          })

          container.appendChild(grid)
        })

        dropdownView.panelView.element!.appendChild(container)
      })

      return dropdownView
    })
  }
}